import { c as _c } from "react/compiler-runtime";
import type { StandardSvgProps } from 'src/components/svg/StandardSvgProps';
import classNames from 'classnames';
import svgStyles from './SVGStyles.module.css';
export default function TextListSvg(t0) {
  const $ = _c(7);
  const {
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = classNames(svgStyles.SDefaultSvg, className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  let t3;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <rect width="13.593" height="1.942" rx="0.97100002" id="rect2" x="0" y="0" />;
    t3 = <rect width="13.593" height="1.942" rx="0.97100002" id="rect4" x="0" y="3.8829999" />;
    t4 = <rect width="13.593" height="1.942" rx="0.97100002" id="rect6" x="0" y="7.7670002" />;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
  } else {
    t2 = $[2];
    t3 = $[3];
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t1) {
    t5 = <svg className={t1} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13.593 9.7089993">{t2}{t3}{t4}</svg>;
    $[5] = t1;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
}